import React from 'react';
import { Text, TextType } from 'ui-components/components/text';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import style from './style.module.less';

export const ZeroState = () => {
  return (
    <div className={style['zero-state']}>
      <Text textType={TextType.H4} value={<FormattedMessage {...messages.zeroStateHeader} />} />
      <Text textType={TextType.Caption} value={<FormattedMessage {...messages.zeroStateLabel} />} />
    </div>
  );
};
